import React from 'react';

import { Calendar } from 'primereact/calendar';
import type { selectedDate } from 'types/interfaces';
import { timestampToFormattedDate } from 'utils/date-utils';

interface Props {
  dateFilter: selectedDate;
  onChange: (date: Date) => void;
}

export const DistributionSingleDayPicker: React.FC<Props> = ({
  dateFilter,
  onChange
}) => (
  <Calendar
    value={timestampToFormattedDate(dateFilter.dateFrom) ?? null}
    onChange={(event) => {
      if (event.value instanceof Date) {
        onChange(event.value);
      }
    }}
    dateFormat="dd.mm.yy"
    placeholder="Выберите день"
    tooltip="Выполнить наряд в дату"
    tooltipOptions={{ position: 'top' }}
    showIcon
    readOnlyInput
  />
);
